<mat-card class="logout-popup-card">
    <mat-card-title class="logout-popup-title">
        Session Timeout
    </mat-card-title>
    <mat-card-content class="logout-popup-content">
        @if (autoLoggedOut) {
            <p>You've been signed out. Please press OK to continue.</p>
        } @else {
            <p>{{ data.message }} You will be logged out in <strong>{{ countdown }}</strong> seconds.</p>
        }
    </mat-card-content>
    <mat-card-actions class="logout-popup-actions">
        @if (!autoLoggedOut) {
            <button mat-raised-button color="primary" (click)="keepSignedIn()">Keep Me Signed In</button>
        }
        <button mat-raised-button color="warn" (click)="confirmLogout()">OK</button>
    </mat-card-actions>
</mat-card>